export enum ResponseView {
  full = 'full',
  compact = 'compact',
  compactCalendar = 'compact-calendar',
  default = '',
  reservationsFull = 'reservations-full',
}
